// extracted by mini-css-extract-plugin
export default {"btn_wrapper":"AllTrades_btn_wrapper__Sweu+","btn":"AllTrades_btn__65lIf"};